import { buildAreasUrl } from '@/helpers/api-url-builder';
import { authHeader } from '@/helpers/auth-header';
import { responseToJson, handleResponse } from '@/helpers/response-helpers';

export const areaService = {
  createArea,
  updateArea,
  uploadPhoto,
  deletePhoto
};

const headers = {
  'Content-Type': 'application/json',
  'Accept': 'application/json'
};

function createArea(propertyId, payload){
  const requestOptions = {
    method: 'POST',
    headers: {
      ...headers,
      ...authHeader(),
      },
    body: JSON.stringify({ area: payload })
  };

  return fetch(buildAreasUrl(propertyId), requestOptions)
          .then(handleResponse)
          .then(responseToJson);
}

function updateArea(propertyId, areaId, payload){
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...headers,
      ...authHeader(),
      },
    body: JSON.stringify({ area: payload })
  };

  return fetch(buildAreasUrl(propertyId, areaId), requestOptions)
          .then(handleResponse)
          .then(responseToJson);
}

function uploadPhoto(propertyId, areaId, attachment){
  const data = new FormData();

  data.append(`area[photos_attributes][][name]`, attachment.name);
  data.append(`area[photos_attributes][][date_of_photo]`, attachment.date);
  data.append(`area[photos_attributes][][image]`, attachment.image);

  const requestOptions = {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      ...authHeader(),
    },
    body: data
  };
  return fetch(buildAreasUrl(propertyId, areaId), requestOptions)
          .then(handleResponse)
          .then(responseToJson);
}

function deletePhoto(propertyId, areaId, attachmentId){
  let remove = {
    "area": {
      "photos_attributes": [{
        "id": attachmentId,
        "_destroy": 1
      }]
    }
  }

  const requestOptions = {
    method: 'PUT',
    headers: {
      ...headers,
      ...authHeader(),
    },
    body: JSON.stringify(remove)
  };

  return fetch(buildAreasUrl(propertyId, areaId), requestOptions)
          .then(handleResponse)
          .then(responseToJson);
}
